// axios
import axios from 'axios';

const baseURL = process.env.VUE_APP_API_URL || 'https://leadbox.ec/api/v1';

const instance = axios.create({
  baseURL,
  // You can add your headers here
});

instance.interceptors.request.use(
  (config) => {
    let companyUuid = null;
    let token = null;

    if (typeof window !== 'undefined' && window.localStorage) {
      companyUuid = window.localStorage.getItem('companyUuid');
      token = window.localStorage.getItem('accessToken');
    }

    if (!config.headers) {
      config.headers = {};
    }

    // Identificar si la petición va a la API interna de Leadbox
    const url = config.url || '';
    const isAbsolute = url.startsWith('http://') || url.startsWith('https://');
    const isInternal = !isAbsolute || url.startsWith(baseURL) || url.includes('leadbox.ec');

    if (isInternal) {
      // Normalizar o inyectar header Company si no viene o viene inválido/nulo
      const existingCompany = config.headers.Company || config.headers.company;
      const isInvalidCompany = !existingCompany || existingCompany === 'undefined' || existingCompany === 'null';

      if (isInvalidCompany) {
        if (companyUuid) {
          config.headers.Company = companyUuid;
        }
      } else if (!config.headers.Company && config.headers.company) {
        config.headers.Company = config.headers.company;
      }

      // Asegurar header Authorization si hay token en localStorage
      const existingAuth = config.headers.Authorization || config.headers.authorization;
      if (!existingAuth && token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => Promise.reject(error),
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (typeof window !== 'undefined') {
        if (window.localStorage) {
          window.localStorage.removeItem('accessToken');
          window.localStorage.removeItem('userInfo');
        }
        if (window.location && window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }

    if (error.response && error.response.status === 403) {
      const data = error.response.data || {};
      const errorMsg = typeof data.error === 'string' ? data.error : (data.message || '');
      const isCompanySuspended = data.code === 'company_suspended'
        || (typeof errorMsg === 'string' && (
          errorMsg.toLowerCase().includes('desactivad')
          || errorMsg.toLowerCase().includes('suspendid')
        ));

      if (isCompanySuspended) {
        window.dispatchEvent(new CustomEvent('company:suspended', {
          detail: {
            message: errorMsg,
            data,
          },
        }));
      }
    }
    return Promise.reject(error);
  },
);

export default instance;
